module.exports = __webpack_public_path__ + "static/logo_TellMeMore_black-2dd9385ba56248063ad335c19b05661f.png";